import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const AlertIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M12.984 13.6162V9.58421H11.016V13.6162H12.984ZM12.984 17.6002V15.5842H11.016V17.6002H12.984ZM0.984009 20.6002L12 1.61621L23.016 20.6002H0.984009Z'
                fill='currentColor'
            />
        </>
    ),
})

AlertIcon.displayName = 'AlertIcon'
